/**
 * Authentication Configuration
 * 
 * Centralized configuration for authentication-related settings
 */

export const AUTH_CONFIG = {
  /**
   * Inactivity timeout in milliseconds
   * Default: 30 minutes (1800000 ms)
   * 
   * User will be automatically logged out after this period of inactivity
   */
  INACTIVITY_TIMEOUT: 30 * 60 * 1000, // 30 minutes

  /**
   * Session check interval in milliseconds
   * Default: 5 seconds (5000 ms)
   * 
   * How often to check for activity in other tabs
   */
  SESSION_CHECK_INTERVAL: 15 * 1000, // 15 seconds


  /**
   * Local storage keys
   */
  STORAGE_KEYS: {
    AUTH_DATA: 'data',
    TOKEN: 'token',
    IS_LOGGED_IN: 'isLoggedIn',
    LAST_ACTIVITY: 'lastActivity',
  },

  /**
   * Events to track for user activity
   */
  ACTIVITY_EVENTS: [
    'mousedown',
    'mousemove',
    'keypress',
    'keydown',
    'scroll',
    'touchstart',
    'click',
    'wheel',
  ],
}